import React, { useState } from 'react';
import { AccordionItem } from '../ui/Accordion';
const faqs = [{
  question: 'Cât costă serviciul pentru compania mea?',
  answer: 'Serviciul este 100% gratuit pentru companiile care aplică. Noi suntem remunerați de către băncile partenere doar în momentul în care obții finanțarea. Nu există costuri ascunse sau taxe de consultanță pentru tine.'
}, {
  question: 'Ce condiții de eligibilitate trebuie să îndeplinesc?',
  answer: 'În general, căutăm companii cu minim 12 luni de activitate și o cifră de afaceri de peste 50.000 EUR. Totuși, fiecare bancă are criterii diferite. Platforma noastră verifică automat aceste criterii pentru a te potrivi doar cu băncile unde ai șanse reale de aprobare.'
}, {
  question: 'Cât durează procesul de aprobare?',
  answer: 'Pre-calificarea pe platformă este instantanee. După ce dosarul este complet și trimis către bancă, primești de obicei o ofertă fermă în 24-48 de ore, în funcție de complexitatea solicitării și de bancă.'
}, {
  question: 'Datele mele sunt în siguranță?',
  answer: 'Absolut. Folosim criptare de nivel bancar pentru toate datele transmise și stocate. Nu partajăm informațiile tale cu nimeni în afara băncilor partenere pe care le selectezi explicit pentru a primi oferte.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-white" data-id="element-107">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl" data-id="element-108">
        <div className="text-center mb-16" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-110">
            Întrebări frecvente
          </h2>
          <p className="text-lg text-slate-600" data-id="element-111">
            Tot ce trebuie să știi despre procesul de finanțare prin CreditArea.
          </p>
        </div>

        <div className="space-y-2" data-id="element-112">
          {faqs.map((faq, index) => <AccordionItem key={index} title={faq.question} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-113">
              {faq.answer}
            </AccordionItem>)}
        </div>
      </div>
    </section>;
}